;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
	"inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden",
	{
		defaultVariants: {
			variant: "default",
		},
		variants: {
			variant: {
				accent:
					"border-transparent bg-accent text-accent-foreground [a&]:hover:bg-accent/90",
				default:
					"border-transparent bg-primary text-primary-foreground [a&]:hover:bg-primary/90",
				destructive:
					"border-transparent bg-destructive text-white [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
				muted:
					"border-transparent bg-muted text-muted-foreground [a&]:hover:bg-muted/90",
				outline:
					"text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
				secondary:
					"border-transparent bg-[color-mix(in_oklch,var(--color-secondary),white_60%)] text-secondary-foreground [a&]:hover:bg-[color-mix(in_oklch,var(--color-secondary),white_90%)",
				success:
					"border-transparent bg-[color-mix(in_oklch,var(--color-success),white_10%)] text-success-foreground [a&]:hover:bg-[color-mix(in_oklch,var(--color-success),white_5%)",
			},
		},
	},
);

type BadgeVariant = VariantProps<typeof badgeVariants>["variant"];

interface BadgeProps
	extends React.ComponentProps<"span">,
		VariantProps<typeof badgeVariants> {
	asChild?: boolean;
}

function Badge({
	className,
	variant = "default",
	asChild = false,
	...props
}: Readonly<BadgeProps>) {
	const Comp = asChild ? Slot : "span";

	return (
		<Comp
			className={cn(badgeVariants({ variant }), className)}
			data-slot="badge"
			{...props}
		/>
	);
}

export { Badge, type BadgeProps, type BadgeVariant, badgeVariants };
